import { render, staticRenderFns } from "./KameButton.vue?vue&type=template&id=1323021a&"
import script from "./KameButton.vue?vue&type=script&lang=js&"
export * from "./KameButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports